import {create} from "zustand/react";

export interface OrderState {
    searchText: string;
    selectedOrderId?: string;
    setSearchText: (text: string) => void;
    setSelectedUserId: (id: string) => void;
}

export const useUserStore = create<OrderState>((set, getState) => ({
    searchText: "",
    selectedOrderId: undefined,
    setSearchText: (text) => {
        set((state) => {
            return {
                ...state,
                searchText: text
            }
        })
    },
    setSelectedUserId: (id) => {
        set((state) => ({
            ...state
        }));
    },
}));
